<div class="inner-page-header py-5 text-white">
  <div class="container px-lg-5">
    <h1 class="display-5 fw-bold text-uppercase mb-2">Financial Support & Welfare Works</h1>
    <p class="lead mb-0 text-orange-light">Empowering Students Through Support</p>
  </div>
</div>

<div class="container px-lg-5 py-5">
  <!-- Official Chart Section -->
  <div class="content-card p-4 p-md-5 shadow-sm rounded-4 bg-white border-top border-5 border-success mb-5 mx-auto">
    <h3 class="fw-bold mb-4 text-success border-bottom pb-2 text-start">
      <i class="fa-solid fa-hand-holding-dollar me-2"></i> Official Welfare Information Chart
    </h3>

    <div class="image-wrapper shadow-lg border rounded-4 overflow-hidden mb-4">
      <img src="assets/img/quick-links/financial_support.png" alt="Financial Support Official Chart" class="img-fluid w-100">
    </div>

    <div class="text-start mt-4">
      <a href="assets/img/quick-links/financial_support.png" target="_blank"
        class="btn btn-warning fw-bold text-dark px-4 py-2">
        <i class="fa-solid fa-up-right-from-square me-2"></i> Open Image In New Tab
      </a>
    </div>
  </div>

  <!-- Gallery Section -->
  <h3 class="fw-bold text-success mb-4 text-uppercase border-bottom pb-2">
    <i class="fa-solid fa-images me-2"></i> Welfare Activities Gallery
  </h3>

  <div class="row g-3">
    <div class="col-6 col-md-3" *ngFor="let img of welfareImages">
      <div class="rounded-4 overflow-hidden shadow-sm border border-2 border-white">
        <img [src]="img" alt="Financial Welfare Activity" class="img-fluid w-100" style="object-fit: cover; height: 200px;">
      </div>
    </div>
  </div>
</div>
